import React from 'react'
import { Grid } from "@mui/material";
import Stack from "@mui/material/Stack";
import UiInput from '../../../_uiMocks/_uiComponents/UiInput';
import {
    UiButton,
} from "../../../_uiComponents/common/form/UiButton";

export default function PointBudgetApprovalRequestForm(props) {

    return (
        <>

            <Grid container spacing={2}>
                <Grid
                    item
                    xs={12}
                    lg={12}
                    sx={{ mt: 2 }}
                >
                    <UiInput
                        label="Requested Points"
                        name="requestedPoints"
                    />
                </Grid>
                <Grid
                    item
                    xs={12}
                    lg={12}

                >
                    <UiInput
                        label="Remarks"
                        multiline={
                            true
                        }
                        minRows={3}
                        maxRows={5}
                        name="description"
                    />
                </Grid>
                <Grid item xs={12} lg={12}>
                    <Stack
                        spacing={2}
                        direction="row"
                        justifyContent="end"
                        sx={{
                            width: "100%",
                            pt: 0.6,
                        }}
                    >
                        <UiButton
                            name="Cancel"
                            variant="outlined"
                            size="small"

                        />
                        <div className='sba-raise-request-btn'>
                            <UiButton
                                name="Raise Request"
                                variant="contained"
                                size="small"

                            />
                        </div>
                    </Stack>
                </Grid>
            </Grid>

        </>
    )
}
